<template>
  <div class="ajax-form">
    <input type="hidden" name="category" value="1">
    <div class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">Assistance VU - 4097</div>
          <div class="page__head-title__notice">(* champs obligatoires)</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form_ttl">Informations Assistance VUL - 4097</div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Type de client</div>
          <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
            <input v-model="assistanceVUVL.is_individual" name="is_individual" type="radio" value="0" checked/> Société
            <input v-model="assistanceVUVL.is_individual" name="is_individual" type="radio" value="1" /> Particulier
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Nom de l'assuré</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}">
          </div>
        </div>
      </div>

      <div class="col-12" v-if="!isIndividual">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Numéro RCS</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.rcs" maxlength="9" class="input_n" :class="{input_red_shadow: hasError('rcs')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Nom du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.nom" class="input_n" :class="{input_red_shadow: hasError('nom')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Prénom du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.prenom" class="input_n" :class="{input_red_shadow: hasError('prenom')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Adresse du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.adresse" class="input_n" :class="{input_red_shadow: hasError('adresse')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Code postal</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceVUVL.cp" maxlength="5" class="input_n" :class="{input_red_shadow: hasError('cp')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Ville</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceVUVL.ville" class="input_n" :class="{input_red_shadow: hasError('ville')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Téléphone du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceVUVL.tel" maxlength="10" class="input_n" :class="{input_red_shadow: hasError('tel')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Email du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceVUVL.email" class="input_n" :class="{input_red_shadow: hasError('email')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Date d'effet</div>
          <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
            <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"/>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form_ttl">Information sur l'assistance :</div>
      </div>

      <div class="col-12">
        <div class="form__item relative">
          <div class="form__item__label form__item__label--required">Nombre de véhicules VUL à assister</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceVUVL.nb_vehicles_base" maxlength="3" class="input_n" :class="{input_red_shadow: hasError('nb_vehicles_base')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Options</div>
          <div class="form__item__input-wrapper form__item__input-wrapper">
            <select v-model="assistanceVUVL.option" name="option" id="option" class="select_n"
                    :disabled="true"
                    :class="{input_red_shadow: hasError('option')}"
            >
              <option value="0">Franchise 0 km et Dépannage/Remorquage 300 euros</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item justify-content-center mt-3 mb-3">
          <div class="form__item__submit">
            <Preloader v-if="isSending"/>
            <input v-else type="submit" name="Submit" value="Voir le devis" class="form_bt btnSendAjax form_confirm_button form__item__submit__button btn btn-block" @click="onSubmit">
          </div>
        </div>
      </div>
    </div>
    <ValidationErrors :errorsList="errors"/>
  </div>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '@/mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader'
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask'
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';
    import CustomTextInput from "../DealerInsuranceCampingCar/CustomTextInput";
    import CustomRadioInput from "../DealerInsuranceCampingCar/CustomRadioInput";

    const INITIAL_FIELDS_VALUES = Object.freeze({
        civilite: 3,
        name_of_signatory: '',
        rcs: '',
        nom: '',
        prenom: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        // fax: '',
        email: '',
        nb_vehicles_base: '',
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        jour_vente: 1,
        mois_vente: 1,
        annee_vente: new Date().getFullYear(),
        type: 5,
        is_individual: null,
        option: 0
    });

    const CAR_TYPE_VP = 1;
    const CAR_TYPE_VU = 2;
    const CAR_TYPE_4X4 = 3;

    const CIVILITY_M = 0;
    const CIVILITY_MLLE = 1;
    const CIVILITY_MME = 2;
    const CIVILITY_SOCIETY = 3;

    export default {
        name: 'BrokerAssistanceVUVL',
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker, CustomTextInput, CustomRadioInput},
        mixins: [garantieFieldsLists],
        data() {
            return {
                assistanceVUVL: {...INITIAL_FIELDS_VALUES},
                errors: {},
                isSending: false,
                searchResult: null,
                isClientSearching: false,
                effectiveDateInput: '',
                shippingDateInput: '',
                circulationDateInput: '',
                birstdayDateInput: '',
                isVehicleSearching: false,
                searchVehicleResult: null,
                acceptedVehicleResult: false,
            }
        },
        computed: {
            isEditAssistance() {
                return !!this.$route.params.id
            },
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
            mechanic_id() {
              return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
            isIndividual() {
              return this.assistanceVUVL.is_individual == 1;
            },
        },
        watch: {
        },
        methods: {
            searchByRegNumber: DEBOUNCE(function (val) {
                this.assistanceVUVL.immatriculation = this.assistanceVUVL.immatriculation.toUpperCase();

                let matched = this.assistanceVUVL.immatriculation.match(/(^([0-9]{2,}-[A-Z]{2,}-[0-9]{2,})+$)|(^([A-Z]{2,}-[0-9]{2,}-[A-Z]{2,})+$)/g);

                if (matched) {
                    let url = 'client/registration',
                        data = {
                            regNumber: this.assistanceVUVL.immatriculation,
                            ccar: true
                        };
                    this.isVehicleSearching = true;
                    this.apiPost(url, data, false)
                    .then(response => {
                        if (response.data.info) {
                            this.searchVehicleResult = response.data.info;
                        }

                        this.isVehicleSearching = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.isVehicleSearching = false;
                        this.acceptedVehicleResult = false;
                    })
                }
            }, 1000),
            searchClient: DEBOUNCE(function (val) {

                if (this.assistanceVUVL.tel.length > 2) {
                    let url = 'client/searchOne',
                        data = {
                            tel: this.assistanceVUVL.tel
                        };
                    this.isClientSearching = true;
                    this.apiGet(url, data, false)
                    .then(response => {
                        if (response.data.client) {
                            this.searchResult = response.data.client;
                        }

                        this.isClientSearching = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.isClientSearching = false;
                    })
                }
            }, 1000),
            serializeData() {
                this.assistanceVUVL.mechanic_id = this.mechanic_id;
                this.assistanceVUVL.nb_vehicles = Number(this.assistanceVUVL.nb_vehicles_vu) + Number(this.assistanceVUVL.nb_vehicles_vl);
                return this.assistanceVUVL;
            },
            onSubmit(event) {
                this.validateEffectiveDate();
                this.isSending = true;
                let url = 'garantie/assistance-vul4097',
                    data = this.serializeData();
                if (this.isEditAssistance) {
                    url = 'garantie/assistance-vul4097/' + this.$route.params.id + '/edit';
                }
                this.apiPostFormData(url, data).then((response) => {
                    this.isSending = false;
                    this.errors = {};
                    if (response.data.calcQuotes)
                        this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                    this.showSuccessNotification(response.data.message, '');
                    let id = response.data.quote.id;
                    this.$router.push('/assistance-vul4097-view/' + id);
                }).catch(error => {
                    this.isSending = false;
                    this.errors = error.response.data;

                    if (error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                        this.errors.errors = {};
                        this.errors.errors.error = [error.response.data.message];
                    }
                })
            },
            getGuarantyInfo() {
                let url = 'garantie/assistance-vul4097/' + this.$route.params.id;
                this.apiGet(url).then(response => {
                    this.assistanceVUVL = this.parseQuoteData(response.data.quote);
                    this.assistanceVUVL.nb_vehicles_vu = response.data.nb_vu;
                    this.assistanceVUVL.nb_vehicles_vl = response.data.nb_vl;
                }).catch(error => {
                    console.log(error)
                })
            },
            parseClientInfo(client) {
                this.assistanceVUVL.name_of_signatory = client.name_of_signatory;
                this.assistanceVUVL.rcs = client.rcs;
                this.assistanceVUVL.nom = client.last_name;
                this.assistanceVUVL.prenom = client.first_name;
                this.assistanceVUVL.adresse = client.address;
                this.assistanceVUVL.cp = client.zip;
                this.assistanceVUVL.ville = client.city;
                this.assistanceVUVL.tel = client.tel;
                this.assistanceVUVL.email = client.email;
                this.assistanceVUVL.id_client = client.id;
            },
            parseQuoteData(quote) {
                let parsedQuote = {};

                if (quote.client && quote.client.id) {
                    parsedQuote.name_of_signatory = quote.client.name_of_signatory;
                    parsedQuote.rcs = quote.client.rcs;
                    parsedQuote.nom = quote.client.last_name;
                    parsedQuote.prenom = quote.client.first_name;
                    parsedQuote.adresse = quote.client.address;
                    parsedQuote.cp = quote.client.zip;
                    parsedQuote.ville = quote.client.city;
                    parsedQuote.tel = quote.client.tel;
                    parsedQuote.email = quote.client.email;
                    parsedQuote.id_client = quote.client.id;
                }

                if (quote.details) {
                    // if (quote.details.datesParse) {
                    //     let effective_day = quote.details.datesParse.day_effective,
                    //         effective_month = quote.details.datesParse.month_effective - 1,
                    //         effective_year = quote.details.datesParse.year_effective;
                    //     parsedQuote.jour_prise_effet = effective_day;
                    //     parsedQuote.mois_prise_effet = effective_month;
                    //     parsedQuote.annee_prise_effet = effective_year;
                    //
                    //     this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                    //
                    //     parsedQuote.jour_vente = quote.details.datesParse.day_sale;
                    //     parsedQuote.mois_vente = quote.details.datesParse.month_sale;
                    //     parsedQuote.annee_vente = quote.details.datesParse.year_sale;
                    //
                    //     parsedQuote.jour_livraison = quote.details.datesParse.day_delivery;
                    //     parsedQuote.mois_livraison = quote.details.datesParse.month_delivery;
                    //     parsedQuote.annee_livraison = quote.details.datesParse.year_delivery;
                    // }

                  // alert(quote.effective_date);
                  let effective_day = quote.datesParse.day_effective,
                    effective_month = quote.datesParse.month_effective - 1,
                    effective_year = quote.datesParse.year_effective;
                  // alert(effective_day);
                  parsedQuote.jour_prise_effet = effective_day;
                  // alert(parsedQuote.jour_prise_effet);
                  parsedQuote.mois_prise_effet = effective_month;
                  parsedQuote.annee_prise_effet = effective_year;
                  parsedQuote.is_individual = quote.is_individual;

                  this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                  if (quote.nb_vehicles_base) {
                    parsedQuote.nb_vehicles_base = quote.nb_vehicles_base;
                    parsedQuote.option = 0;
                  }

                  parsedQuote.shipping_date = this.moment(quote.details.shipping_date).format('DD/MM/YYYY');
                  this.shippingDateInput = new Date(quote.details.shipping_date);
                }
                this.acceptedVehicleResult = true;
                return parsedQuote;
            },
            validateEffectiveDate() {
                if (!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.assistanceVUVL.jour_prise_effet = date.format('D');
                this.assistanceVUVL.mois_prise_effet = date.format('M');
                this.assistanceVUVL.annee_prise_effet = date.format('YYYY');

                return true;
            },
            validateShippingDate() {
                if (!this.shippingDateInput) return false;
                let date = this.moment(this.shippingDateInput).format('DD/MM/YYYY');
                this.assistanceVUVL.shipping_date = date;
                return true;
            },
            resetEffectiveDate() {
                this.assistanceVUVL.jour_prise_effet = 1;
                this.assistanceVUVL.mois_prise_effet = 1;
                this.assistanceVUVL.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.assistanceVUVL.jour_prise_effet = '';
                this.assistanceVUVL.mois_prise_effet = '';
                this.assistanceVUVL.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if (!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.assistanceVUVL.jour_mise_en_circulation = date.format('D');
                this.assistanceVUVL.mois_mise_en_circulation = date.format('M');
                this.assistanceVUVL.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.assistanceVUVL.jour_mise_en_circulation = '';
                this.assistanceVUVL.mois_mise_en_circulation = '';
                this.assistanceVUVL.annee_mise_en_circulation = '';
            },
            getListOfDurationOprions() {
                let list = [],
                    options = document.getElementById("durationSelect").options;

                for (let option of options) {
                    list.push(+option.value);
                }

                return list;

            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
        },
        beforeRouteLeave(to, from, next) {
            this.assistanceVUVL = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            if (this.$route.params.id) this.getGuarantyInfo();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/BrokerAssistance/BrokerAssistanceVUL4097.vue